import { quittung } from "@kundeninfo/ui/me-design";
import type { QuittungSteuerung } from "@kundeninfo/ui/me-design";

/**
 * QUITTUNGEN DER TICKETS (Spec Teilaufgaben R22, Festlegung 8 des Plans): alle über `quittung()` (Entscheid 81) — eine
 * zur Zeit, im obersten offenen Dialog, sonst am body. Der Adapter gibt dem Hinweis die Klasse `tq` und den Namen
 * (Vorgabe „Quittung") — so finden Tests und E2E sie wie bisher über Rolle `status` und Namen. `quittung()` kennt keine
 * Option `schliessbar` (me-design `elemente/quittung.js`); der zurückgegebene `me-hinweis` beobachtet das Attribut aber
 * (`observedAttributes`, Kreuz und Escape, me-hinweis.js) — der Adapter setzt es, damit Kreuz und Escape bleiben wie in
 * der Bestandsquittung (Pre-flight P02; Wunsch W6 an me-design: Option `schliessbar` an `quittung()`).
 */
export const QUITTUNG_MS = 7_000;

export function ticketReceipt(o: { text: string; rueckgaengig?: () => unknown; an?: Element | null; name?: string }):
    QuittungSteuerung {
  const q = quittung({ text: o.text, dauer: QUITTUNG_MS,
    ...(o.rueckgaengig === undefined ? {} : { rueckgaengig: o.rueckgaengig }), ...(o.an === undefined ? {} : { an: o.an }) });
  q.hinweis.classList.add("tq");
  q.hinweis.setAttribute("aria-label", o.name ?? "Quittung");
  q.hinweis.setAttribute("schliessbar", "");
  return q;
}
